import type { FunctionComponent } from 'react';

import type { ChecklistEntity } from './types';

type CheckListProps = Pick<ChecklistEntity, 'id' | 'text'>;

export const CheckList: FunctionComponent<CheckListProps> = ({ text }) => {
  return <strong>{text}</strong>;
};
